import(/* webpackMode: "eager" */ "C:\\Users\\piete\\Documents\\Work\\Websites\\call-a-doctor-website 2\\call-a-doctor-website\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentForm"] */ "C:\\Users\\piete\\Documents\\Work\\Websites\\call-a-doctor-website 2\\call-a-doctor-website\\src\\components\\AppointmentForm.tsx");
